<template>
  <div class="animated fadeIn">
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Email"
          label-for="email"
          :label-cols="labelCols">
          <b-form-input 
            id="email"
            v-model.trim= "$v.email.$model" 
            :state="emailValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="emailFeedback">
            {{ emailInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Apellido"
          label-for="apellido"
          :label-cols="labelCols">
          <b-form-input 
            id="apellido"
            class="text-upper"
            v-model.trim= "$v.apellido.$model" 
            :state="apellidoValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="apellidoFeedback">
            {{ apellidoInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Nombre"
          label-for="nombre"
          :label-cols="2">
          <b-form-input 
            id="nombre"
            class="text-upper"
            v-model.trim= "$v.nombre.$model" 
            :state="nombreValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="nombreFeedback">
            {{ nombreInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label-for="admin"
          :label-cols="labelCols">
          <b-form-checkbox 
              id="admin"
              v-model="admin"
              value= true
              unchecked-value= false>
              Administrador
          </b-form-checkbox>
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cancelar</b-button>
      </div>
      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown= 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import { msjAlert } from '../../mixins/msjAlert';
import { required, maxLength, email } from 'vuelidate/lib/validators';


export default {
  name: 'Preregistro',
  components: {
  },
  mixins: [ 
    msjAlert, 
  ],
  data () {
    return {
      email: '',
      apellido: '',
      nombre: '',
      admin: false,

      noValidar: true,
      emailValido: null,
      emailInvalidoMsj: '',
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
  },  
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false;
          if (!this.$v.email.required) {
            this.emailInvalidoMsj = 'Debe ingresar el email del usuario';
          } else if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser válido.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email sólo puede contener hasta 150 caracteres';
          }
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido del usuario';
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();

        let params = {
            email: this.email.toLowerCase().trim(),
            apellido: this.apellido.trim(),
            nombre: this.nombre.trim(),
            admin: this.admin
        }

        this.$store.dispatch('usuario/preregistrar', params)
          .then(()  => this.showAlert('El preregistro se completó con éxito.', 'info', this.registered))
          .catch(error => this.showAlertError(error))
          .finally(() => this.hideSpinner())
      }
    },
    registered() {
      this.$emit('close', true);
    },
    close() {
      this.$emit('close', false);
    },    
  },
  watch: {
  },
  validations: {
    email: {
      required,
      email,
      maxLength: maxLength(150)
    },
    apellido: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
